
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import autobind from 'class-autobind';

import hasEqualProps from 'zoomforth_zfutils/has_equal_props.js';

import VideoishPlayer from 'zoomforth_component_lib/videoish_player.jsx';
import { makeVideoishPlayerPropsForContent } from 'zoomforth_tools/videoish_player.js';

class VideoPlaylistVideoPlayer extends Component {

  constructor(props) {
    super(props);

    this.videoPlayer = null;

    autobind(this);
  }

  shouldComponentUpdate(nextProps) {
    // ensure we stop the previously playing video if the slide changes
    // is this the right place for this? no. but...it works so there's that.
    if (this.props.selectedContentItem && this.props.selectedContentItem.uuid !== nextProps.selectedContentItem.uuid) {
      if (this.videoPlayer && this.videoPlayer._player) {
        this.videoPlayer._player.pause();
      }
    }

    // when using the editor, we set the viewer's selected content but we do
    // not want to embed and render this component again.
    if (!hasEqualProps(this.props.contentItem, nextProps.contentItem, ['asset', 'tile_display_image'])) {
      return true;
    }

    return false;
  }

  componentWillUnmount() {
    this.videoPlayer = null;
  }

  render() {
    const { 
      asset,
      autoplay,
      contentItem,
      onEnded,
      onError,
      onPause,
      onPlay,
      onSeeked,
      onStart,
      onTimeUpdate
    } = this.props;

    const videoishPlayerProps = makeVideoishPlayerPropsForContent(contentItem, asset);
    const { id, posterImageUrl } = videoishPlayerProps;

    // Generate a unique key based on the posterImageUrl. The idea here is that
    // changing the poster image should force the video player to update. The
    // problem is the VideoishPlayer doesn't support updates due to the way we
    // instantiate VideoJS. This means it's the parent's responsibility to
    // mount / unmount the component and the best means of doing that is
    // through React keys. A changed key means the whole thing remounts.
    const uniqueKey = `${id}-${posterImageUrl}`;

    return (
      <div key={uniqueKey} className={`video-player current-content-uuid-${contentItem.uuid}`}>
        <VideoishPlayer 
          { ...videoishPlayerProps }
          autoplay={autoplay}
          getVideoPlayer={(ref)=> this.videoPlayer = ref}
          onEnded={(videoEventData)=> { onEnded(contentItem, videoEventData); }}
          onError={(videoEventData)=> { onError(contentItem, videoEventData); }}
          onPause={(videoEventData)=> { onPause(contentItem, videoEventData); }}
          onPlay={(videoEventData)=> { onPlay(contentItem, videoEventData); }}
          onSeeked={(videoEventData)=> { onSeeked(contentItem, videoEventData); }}
          onStart={(videoEventData)=> { onStart(contentItem, videoEventData); }}
          onTimeUpdate={(videoEventData)=> { onTimeUpdate(contentItem, videoEventData); }}

        />
      </div>
    );
  }
}

VideoPlaylistVideoPlayer.propTypes = {
  asset: PropTypes.object.isRequired,
  contentItem: PropTypes.object.isRequired,
  autoplay: PropTypes.bool.isRequired,
  onEnded: PropTypes.func,
  onError: PropTypes.func,
  onPause: PropTypes.func,
  onPlay: PropTypes.func,
  onSeeked: PropTypes.func,
  onStart: PropTypes.func,
  onTimeUpdate: PropTypes.func
};

VideoPlaylistVideoPlayer.defaultProps = {
  onEnded: noop,
  onError: noop,
  onPause: noop,
  onPlay: noop,
  onSeeked: noop,
  onStart: noop,
  onTimeUpdate: noop
};


export default VideoPlaylistVideoPlayer;
